import React, {Component} from 'react';
import Checkbox from "../../../shared/forms/Checkbox";
import LoadingButton from "../../../shared/ui/LoadingButton";


class AttachTaskGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTaskGroups: []
    }
  }

  handleCheck(e) {
    let {name} = e.target;
    if(this.state.selectedTaskGroups.includes(name)) {
      this.setState({
        selectedTaskGroups: this.state.selectedTaskGroups.filter(tg => tg !== name)
      })
    } else {
      this.setState({
        selectedTaskGroups: [...this.state.selectedTaskGroups, name]
      })
    }
  }

  render() {
    let {configTaskGroups, isLoading} = this.props;

    return (
      <div className="modal-body">
        { configTaskGroups.map(tg => (
          <Checkbox
            key={tg.guid}
            name={tg.guid}
            label={tg.name}
            checked={this.state.selectedTaskGroups.includes(tg.guid)}
            onChange={(e) => this.handleCheck(e)}/>
        ))}
        <div className="modal-footer">
          <LoadingButton
            primary
            onClick={() => this.props.onAttachTasks(this.state.selectedTaskGroups)}
            isLoading={isLoading}
            text="Attach Task Groups"
          />
        </div>
      </div>
    );
  }
}

export default AttachTaskGroups;
